import dayjs from '@/libs/dayjs'
import { parseJwt } from '@/libs/helpers'

export const isAuthenticated = (): boolean => {
    try {
        const jwt = localStorage.getItem('JWT')
        if (!jwt) return false
        const parsedJWT = parseJwt(jwt)

        if (!parsedJWT) return false
        return dayjs().unix() < dayjs.unix(parsedJWT.exp).unix()
    } catch {
        return false
    }
}

export const isSpectator = (): boolean => {
    try {
        const jwt = localStorage.getItem('JWT')
        if (!jwt) return false
        const parsedJWT = parseJwt(jwt)

        if (!parsedJWT) return false
        return !!parsedJWT.is_spectator
    } catch {
        return false
    }
}
